module.exports = __webpack_public_path__ + "img/zhengshu2.bc8b2d62.png";